import { render, staticRenderFns } from "./CourseCorrelationInfoTitle.vue?vue&type=template&id=520e56a4&scoped=true&"
var script = {}
import style0 from "./CourseCorrelationInfoTitle.vue?vue&type=style&index=0&id=520e56a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520e56a4",
  null
  
)

export default component.exports